export const selectAuthenticated = state => {
    return Boolean(state.auth.user);
};
export const selectAuthError = state => state.auth.error;
export const selectAuthLoading = state => state.auth.loading;
export const selectUser = state => state.auth.user;
export const selectToken = state => {
    return state.auth.tokenType + ' ' + state.auth.accessToken;
};
